module.exports = __webpack_public_path__ + "img/MW.b253d817.png";